var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditLogLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.375C7.5 2.339 8.34 1.5 9.375 1.5H9.75C10.7446 1.5 11.6984 1.89509 12.4017 2.59835C13.1049 3.30161 13.5 4.25544 13.5 5.25V7.125C13.5 8.161 14.34 9 15.375 9H17.25C18.2446 9 19.1984 9.39509 19.9017 10.0983C20.6049 10.8016 21 11.7554 21 12.75V16.125C21 17.16 20.16 18 19.125 18H9.375C8.87772 18 8.40081 17.8025 8.04917 17.4508C7.69754 17.0992 7.5 16.6223 7.5 16.125V3.375Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25041C15.0018 3.98895 14.5475 2.76937 13.721 1.81641C15.3943 2.25637 16.9207 3.13288 18.1441 4.35629C19.3675 5.57971 20.244 7.10612 20.684 8.77941C19.731 7.95289 18.5115 7.49866 17.25 7.50041H15.375C15.2755 7.50041 15.1802 7.4609 15.1098 7.39057C15.0395 7.32025 15 7.22486 15 7.12541V5.25041ZM4.875 6.00041H6V16.1254C6 17.0205 6.35558 17.879 6.98851 18.5119C7.62145 19.1448 8.47989 19.5004 9.375 19.5004H16.5V20.6254C16.5 21.6604 15.66 22.5004 14.625 22.5004H4.875C4.37772 22.5004 3.90081 22.3029 3.54917 21.9512C3.19754 21.5996 3 21.1227 3 20.6254V7.87541C3 6.83941 3.84 6.00041 4.875 6.00041Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLogLogout);
export default __webpack_public_path__ + "static/media/Audit Log Logout.13b9a32bff7456666b4b7488789e99db.svg";
export { ForwardRef as ReactComponent };